import React, { useMemo } from 'react';

const ALGORITHMS = [
    { label: 'الگو اول ( فروش )', value: 'First', icon: 'feather-package', description: 'الگوی استاندارد برای فروش کالا و خدمات' },
    { label: 'الگو دوم ( فروش ارز )', value: 'Second', icon: 'feather-dollar-sign', description: 'الگوی مخصوص معاملات ارزی' },
    { label: 'الگو سوم ( طلا،جواهر،پلاتین )', value: 'Third', icon: 'feather-gift', description: 'الگوی خاص برای فلزات گرانبها' },
    { label: 'الگو چهارم ( قرارداد پیمانکاری )', value: 'Fourth', icon: 'fa fa-hammer', description: 'الگوی مربوط به قراردادهای پیمانکاری' },
    { label: 'الگو پنجم ( قبوض خدماتی )', value: 'Fifth', icon: 'feather-zap', description: 'الگوی مخصوص صدور قبوض خدماتی' },
    { label: 'الگو ششم ( بلیط هواپیما )', value: 'Sixth', icon: 'fa fa-plane', description: 'الگوی مربوط به بلیط حمل و نقل هوایی' },
    { label: 'الگو هفتم ( صادرات )', value: 'Seventh', icon: 'feather-truck', description: 'الگوی مربوط به صادرات کالا' },
    { label: 'الگو هشتم ( بارنامه )', value: 'Eighth', icon: 'feather-file-minus', description: 'الگوی مربوط به حمل و نقل و باربری' },
    { label: 'الگو یازدهم ( بورس اوراق بهادار مبتنی بر کالا )', value: 'Eleventh', icon: 'feather-trending-up', description: 'الگوی مخصوص معاملات بورس کالا' },
    { label: 'الگو سیزدهم ( فروش خدمات بیمه ای )', value: 'Thirteenth', icon: 'feather-shield', description: 'الگوی مربوط به فروش خدمات بیمه‌ای' },
];

function InvoiceAlgorithmStep({ formData, onDataChange, isInvoiceTypeDisabled, readOnly }) {

    // وضعیت فعال/غیرفعال بودن کلی انتخاب الگو
    const isAlgoDisabled = isInvoiceTypeDisabled.algo;

    // فیلتر کردن الگوها بر اساس نوع صورتحساب (منطق حفظ شده)
    const filteredAlgorithms = useMemo(() => {
        if (formData.invoiceType === 'Second_type') {
            return ALGORITHMS.filter(algo =>
                algo.value === 'First' ||
                algo.value === 'Third' ||
                algo.value === 'Thirteenth'
            );
        }
        return ALGORITHMS;
    }, [formData.invoiceType]);

    // اگر الگو غیرفعال بود، آن را ریست کنید (یا منطق خود را حفظ کنید)
    const handleSelect = (value) => {
        if (!isAlgoDisabled && !readOnly) {
            onDataChange({ invoiceAlgo: value });
        }
    };

    const renderCard = (item, isSelected, isItemDisabled) => {
        const cardClasses = isSelected
            ? "px-3 py-2 mb-3 d-flex align-items-center justify-content-between border border-primary rounded-1 position-relative cursor-pointer bg-light-primary h-100"
            : isItemDisabled
                ? "px-3 py-2 mb-3 d-flex align-items-center justify-content-between border border-dashed border-gray-3 rounded-1 position-relative bg-light text-muted cursor-not-allowed h-100"
                : "px-3 py-2 mb-3 d-flex align-items-center justify-content-between border border-dashed border-gray-3 rounded-1 position-relative cursor-pointer h-100";

        const handleCardClick = () => {
            if (!isItemDisabled) {
                handleSelect(item.value);
            }
        };

        return (
            <div className="col-lg-4 col-sm-6 col-12 mb-3" key={item.value}>
                <div className={cardClasses} onClick={handleCardClick} style={{ minHeight: '70px' }}>
                    <div className="d-flex align-items-center">
                        {/* آیکون */}
                        <div className="wd-30 d-flex justify-content-center align-items-center flex-shrink-0 me-2">
                            <i className={`${item.icon} fs-20 ${isItemDisabled ? 'text-muted' : 'text-primary'}`}></i>
                        </div>

                        <div className="ms-2">
                            {/* عنوان */}
                            <div className={`fw-bold mb-0 fs-12 ${isItemDisabled ? 'text-muted' : 'text-dark'}`}>{item.label}</div>
                            {/* توضیحات */}
                            {/* <div className="mb-0 text-truncate-1-line fs-10 fw-medium text-uppercase text-muted">
                                {item.description}
                            </div> */}
                        </div>
                    </div>

                    {/* تیک انتخاب شده */}
                    {isSelected && (
                        <div className="position-absolute top-0 start-0 translate-middle mt-1 ms-1">
                            <i className="feather-check fs-10 bg-primary text-white p-1 rounded-circle"></i>
                        </div>
                    )}
                </div>
            </div>
        );
    };

    return (
        <div className="step-content">
            <div className="card-body payment-methord p-0">
                <div className="mb-3 d-flex align-items-center justify-content-between">
                    <h6 className="fw-bold mb-0">انتخاب الگوی صورتحساب {!readOnly && <span className="text-danger">*</span>}</h6>
                    {/* <div className="text-muted fw-bold">
                        الگوی فعلی: {ALGORITHMS.find(a => a.value === formData.invoiceAlgo)?.label || 'انتخاب نشده'}
                    </div> */}
                </div>

                {isAlgoDisabled && (
                    <div className="alert alert-info py-2 mb-3 fs-12">
                        <i className="feather-info me-2"></i>
                        انتخاب الگو برای نوع صورتحساب **{formData.invoiceType === 'Paper' ? 'کاغذی' : 'نوع سوم'}** غیرفعال است.
                    </div>
                )}

                <div className="row g-2">
                    {filteredAlgorithms.map(algo =>
                        renderCard(
                            algo,
                            formData.invoiceAlgo === algo.value,
                            isAlgoDisabled || readOnly
                        )
                    )}
                </div>
            </div>
        </div>
    );
}

export default InvoiceAlgorithmStep;